import {Component} from 'preact';
import debounce from 'lodash.debounce';
import cx from 'classnames';

function withIcon ( Component, path = '' ) {
    function Wrapper ( props, context ) {
        return <Component icon={{...context, path}} {...props} />;
    }

    Wrapper.displayName = 'Icon';
    // Wrapper.displayName = Component.displayName || Component.name;
    return Wrapper;
}

const IconSVG = ( {icon, name, color, center, className = '', wrapperClassName = '', ...props} ) => {
    // uses SPAN wrapper for click handlers because event handling is more consistent cross-browser than svg
    const iconClasses = cx(
        `svgi-${name}`,
        className,
        {[`text-${color}`]: color}
    );

    const wrapperClasses = cx(
        wrapperClassName,
        {'flex': center}
    );

    return (
        <span {...props} className={wrapperClasses}>
            <svg className={iconClasses}>
                <use xlinkHref={`${icon.path}#icon-${name}`}></use>
            </svg>
        </span>
    );
};

const svgLoaderDebounced = debounce( () =>{
    window.grunticon && window.grunticon.svgLoadedCallback()
}, 100 );

class IconEmbed extends Component {
    componentDidMount () {
        svgLoaderDebounced();
    }

    render ( {icon, name, color, center, className = ''} ) {
        const iconClasses = cx(
            'svgi-icon',
            `icon-${name}`,
            className,
            {
                [`text-${color}`]: color,
                'flex': center
            }
        );
        return <i className={iconClasses} data-grunticon-embed></i>
    };
}

class Icon extends Component {
    static ui = withIcon( IconSVG, '/svg/ui-defs.svg' );
    static multicolor = withIcon( IconSVG, '/svg/multicolor-defs.svg' );
    static product = withIcon( IconSVG, '/svg/products-defs.svg' );
    static logo = withIcon( IconSVG, '/svg/logos-defs.svg' );
    static flag = withIcon( IconSVG, '/svg/flags-defs.svg' );
    static embed = withIcon( IconEmbed );
}

export default Icon;
